module.exports = __webpack_public_path__ + "img/C06TechArcherChariotChampion_ua.389891a5.webp";